import { IPPS, LTCH, PFS, PSYCH } from "../Constants/modelTypes";

const defaultMigration = (loadedRequest) => {
    return loadedRequest;
};

const migratePOAIndicators = (loadedRequest) => {
    if (loadedRequest.diagnosisCodes) {
        for(const code of loadedRequest.diagnosisCodes) {
            if (code.poa === '1') {
                code.poa = 'One';
            }
        }
    }

    return loadedRequest;
};

export default {
    [PFS.toUpperCase()]: [
        {
            from: '1.0.0',
            to: '1.0.1',
            migration: defaultMigration
        }
    ],
    [IPPS.toUpperCase()]: [
        {
            from: '1.0.0',
            to: '1.0.1',
            migration: migratePOAIndicators
        }
    ],
    [PSYCH.toUpperCase()]: [
        {
            from: '1.0.0',
            to: '1.0.1',
            migration: migratePOAIndicators
        }
    ],
    [LTCH.toUpperCase()]: [
        {
            from: '1.0.0',
            to: '1.0.1',
            migration: migratePOAIndicators
        }
    ]
}